import store from '@/store';
import eventHub from '@/scripts/eventHub';
import state from '../state';

class MouseManager {
  constructor(initiator) {
    this.initiator = initiator;
    this.holdTimeout = -1;

    this.mouseMoveHandler = (event) => { this.move(event); };
    this.mouseDownHandler = (event) => { this.down(event); };
    this.mouseUpHandler = (event) => { this.up(event); };
  }

  addEvents() {
    this.initiator.DOMElement.addEventListener('mousemove', this.mouseMoveHandler);
    this.initiator.DOMElement.addEventListener('mousedown', this.mouseDownHandler);
    this.initiator.DOMElement.addEventListener('mouseup', this.mouseUpHandler);
  }

  removeEvents() {
    this.initiator.DOMElement.removeEventListener('mousemove', this.mouseMoveHandler);
    this.initiator.DOMElement.removeEventListener('mousedown', this.mouseDownHandler);
    this.initiator.DOMElement.removeEventListener('mouseup', this.mouseUpHandler);
  }

  move(event) {
    const ex = event.clientX - this.initiator.boundings.left;
    const ey = event.clientY - this.initiator.boundings.top;
    const x = ex - this.initiator.center.x;
    const y = ey - this.initiator.center.y;
    this.initiator.point = { x, y };

    if (store.state.tutorial === 1 && (x > 150 || x < -150) && state.rayActive) {
      store.commit('SET_TUTORIAL', 2);
      eventHub.$emit('start-spawning');
      setTimeout(() => {
        store.commit('SET_TUTORIAL', 3);
      }, 3000);
    }
  }

  down() {
    this.initiator.hold();

    this.holdTimeout = setTimeout(() => {
      if (store.state.tutorial === 0) {
        store.commit('SET_TUTORIAL', 1);
      }
    }, 1000);
  }

  up() {
    this.initiator.release();

    clearTimeout(this.holdTimeout);
  }
}

export default MouseManager;
